import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { ApplicationConfigService } from 'app/core/config/application-config.service';
import { createRequestOption } from 'app/core/request/request-util';
import { Paginate, SearchWithPagination } from 'app/core/request/request.model';
import { Status } from './status.model';
import { DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { MsCrudService } from '../../../shared/services/ms-crud/ms-crud.services';
import { MsGridService } from '../../../shared/services/ms-grid/ms-grid.services';
import { MsServiceCoreService } from '../../../shared/services/ms-service-core/ms-service-core.services';
import { SystemService } from '../../../shared/services/ms-system/ms-system.service';

@Injectable({ providedIn: 'root' })
export class StatusService extends SystemService implements MsCrudService<Status> {
	private resourceApiUrl = this.applicationConfigService.getEndpointFor('api/status', 'vibraerpws');

	constructor(
		private http: HttpClient,
		private applicationConfigService: ApplicationConfigService,
		private _msGridService: MsGridService,
		private _msServiceCoreService: MsServiceCoreService
	) {
		super('StatusService', _msGridService, _msServiceCoreService);
	}

	create(data: Status): Observable<Status> {
		super.create(data);
		return this.http.post<Status>(this.resourceApiUrl, data);
	}

	update(data: Status): Observable<Status> {
		super.update(data);
		return this.http.put<Status>(`${this.resourceApiUrl}/${data.id}`, data);
	}

	delete(data: any): Observable<Status> {
		return new Observable<Status>((subscriber) => {
			this.http.delete<Status>(`${this.resourceApiUrl}/${data}`).subscribe({
				next: () => {
					super.delete(data);
					subscriber.next(data);
					subscriber.complete();
				},
				error: (error) => subscriber.error(error),
			});
		});
	}

	find(data: string): Observable<Status> {
		super.read(data);
		return this.http.get<Status>(
			this.applicationConfigService.getEndpointFor(`${this.resourceApiUrl}/${data}`)
		);
	}

	paginate(req?: SearchWithPagination): Observable<Paginate> {
		const options = createRequestOption(req);
		return this.http.get<Paginate>(`${this.resourceApiUrl}/paginate`, {
			params: options,
		});
	}

	query(req?: SearchWithPagination): Observable<Status[]> {
		const options = createRequestOption(req);
		return this.http.get<Status[]>(this.resourceApiUrl, {
			params: options,
		});
	}

	getDataGrid(): Subject<DataStateChangeEventArgs> {
		return super.getDataGrid();
	}

	executeGrid(grid: GridComponent, state: DataStateChangeEventArgs): void {
		super.executeGrid(grid, state, this.paginate.bind(this));
	}
}
